import type { SVGProps } from 'react';
const SvgLocalParking = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#local_parking_svg__a)">
      <path
        fill="currentColor"
        d="M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6Zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2Z"
      />
    </g>
    <defs>
      <clipPath id="local_parking_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLocalParking;
